import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiError, confirmMatching } from '@uplift/api';


export const useConfirmMatchingMutation = (userId: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation(confirmMatching, {
    onSuccess(response) {
      if ('data' in response) {
        if (response.data.success) {
          queryClient.invalidateQueries({ queryKey: [ 'user', userId, 'matches' ] });
          onSuccess?.();
        }
      }
    },
    onError: (_err: ApiError) => null,
  });
};
